import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'OperatorTag' })({
    outline: {
        display: 'inline-block',
        lineHeight: 0,
        padding: 2,
        borderRadius: 102,
        background: '#F8F8F8',
        cursor: 'default'
    },
    background: {
        display: 'inline-block',
        lineHeight: 0,
        padding: 2,
        borderRadius: 98
    },
    _default: {
        background: '#D7D7D6'
    },
    _blue: {
        background: '#4180F0'
    },
    _red: {
        background: '#F5726A'
    },
    label: {
        textTransform: 'uppercase',
        display: 'inline-block',
        color: '#ECECEC',
        fontSize: 10,
        fontWeight: 500,
        lineHeight: '100%',
        padding: '2px 4px',
        borderRadius: 96,
        border: '1px solid currentColor'
    }
});
